export class InitiateAccountSwitch403Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return InitiateAccountSwitch403Response.attributeTypeMap;
    }
    constructor() {
    }
}
